import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_clook_full",
  "use": "icon-i_clook_full-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_clook_full\"><title>icon_画板</title><path d=\"M26.47,8.27a13.4,13.4,0,1,0,3.91,9.47A13.3,13.3,0,0,0,26.47,8.27Zm-3.82,10.5H17a1,1,0,0,1-1-1h0V12.8a1,1,0,0,1,2.06,0v3.91h4.66a1,1,0,1,1,0,2.06Z\" /><path d=\"M8.15,3.14a1,1,0,0,1,1.3,1.61L5.46,8A1,1,0,0,1,4,7.83a1.06,1.06,0,0,1,.15-1.45Z\" /><path d=\"M25.88,3.14a1,1,0,0,0-1.45.16,1,1,0,0,0,.16,1.45l4,3.23A1,1,0,0,0,30,7.83a1,1,0,0,0-.16-1.45Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol